import { render, staticRenderFns } from "./DiscountSaleDist.vue?vue&type=template&id=d5532b3e&scoped=true&"
import script from "./DiscountSaleDist.vue?vue&type=script&lang=ts&"
export * from "./DiscountSaleDist.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountSaleDist.vue?vue&type=style&index=0&id=d5532b3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5532b3e",
  null
  
)

export default component.exports